"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUserDiary = exports.getUserBookings = exports.getUserRelationships = exports.getUserAccounts = exports.resyncUserProfile = exports.getUserProfile = exports.getUserProfiles = void 0;
const axios_1 = __importDefault(require("axios"));
const baseUrl = '/userProfiles-api';
async function getUserProfiles() {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/1/users/`
    });
    return resp.data;
}
exports.getUserProfiles = getUserProfiles;
async function getUserProfile(userId) {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/1/users/${userId}/profile`
    });
    return resp.data;
}
exports.getUserProfile = getUserProfile;
async function resyncUserProfile(userId) {
    const resp = await (0, axios_1.default)({
        method: 'post',
        url: `${baseUrl}/1/users/${userId}/resync`
    });
    return resp.data;
}
exports.resyncUserProfile = resyncUserProfile;
async function getUserAccounts(userId) {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/1/users/${userId}/accounts`
    });
    return resp.data.accounts;
}
exports.getUserAccounts = getUserAccounts;
async function getUserRelationships(userId) {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/1/users/${userId}/relationships`
    });
    return resp.data;
}
exports.getUserRelationships = getUserRelationships;
async function getUserBookings(userId, startRow, fetchCount) {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/1/users/${userId}/bookings?startAt=${startRow}&limit=${fetchCount}`
    });
    return resp.data;
}
exports.getUserBookings = getUserBookings;
async function getUserDiary(userId, startRow, fetchCount) {
    const resp = await (0, axios_1.default)({
        method: 'get',
        url: `${baseUrl}/1/users/${userId}/diary?startAt=${startRow}&limit=${fetchCount}`
    });
    return resp.data;
}
exports.getUserDiary = getUserDiary;
